import { createRequestTypes } from 'common/websocket-redux';

export const RE_REGISTER_PAY_PERIOD = createRequestTypes(
  'service/RE_REGISTER_PAY_PERIOD',
);
